
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

// 弹窗层级自增，保证后打开的弹窗盖在先打开的弹窗之上
let popupZIndex = 1200;

/**
 * 弹窗外壳
 * - variant="card"：白底卡片 + 顶部橙色缎带标题（绑定手机号 / 填写地址 / 我的中奖）
 * - variant="gift"：礼盒背景（popup-bg），用于中奖 / 未中奖
 */
@Component
export default class PopupShell extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: String, default: 'card' }) readonly variant!: string;
  // card 变体的顶部缎带图
  @Prop({ type: String, default: '' }) readonly header!: string;
  @Prop({ type: Boolean, default: true }) readonly closable!: boolean;
  @Prop({ type: Boolean, default: false }) readonly maskClosable!: boolean;

  zIndex = 0;

  @Watch('value', { immediate: true })
  onValueChange(visible: boolean) {
    if (visible) {
      popupZIndex += 2;
      this.zIndex = popupZIndex;
    }
  }

  close() {
    this.$emit('input', false);
    this.$emit('close');
  }

  handleMask() {
    if (this.maskClosable) this.close();
  }
}
